'use client'

import Image from 'next/image'
import { useMemo, useState } from 'react'

export default function ImageWithFallback(props) {
  const {
    src = null,
    alt = '',
    fallbackUrl = '/img/default/profile-pic.webp',
    id,
    className = 'object-contain',
    sizes = '100vw',
    fill,
    height,
    width,
  } = props

  const [imgError, setImgError] = useState(false)

  const source = useMemo(() => {
    if (imgError) return fallbackUrl
    return typeof src === 'string' && src !== '' && !src.startsWith('undefined')
      ? src
      : fallbackUrl
  }, [src, fallbackUrl, imgError])

  return (
    <Image
      id={id}
      key={id}
      {...(fill && { fill: true })}
      {...(height && { height })}
      {...(width && { width })}
      className={className}
      src={source}
      alt={alt}
      sizes={sizes}
      onError={() => setImgError(true)}
      onLoad={(res) => {
        if (res.naturalWidth === 0) {
          setImgError(true)
        }
      }}
    />
  )
}
